import { toast } from "sonner";
import { appsApi, errMsg, notifyError } from "@/lib/appsApi";

// File row actions shared by the test-files list and the data-packages page.
export const useFileActions = ({ setFiles, load, onChange = () => {} }) => {
  const patch = (id, data) => setFiles((l) => l.map((f) => (f.id === id ? { ...f, ...(data ?? {}) } : f)));

  const notify = async (id) => {
    try {
      const r = await appsApi.post(`/files/${id}/notify`);
      patch(id, r?.data);
      const failed = Array.isArray(r?.data?.failed) ? r.data.failed : [];
      if (failed.length) notifyError(`Emailed ${r.data.sent} tester(s), but these couldn't be reached: ${failed.join(", ")}. The file is still marked as announced.`);
      else toast.success(`Emailed ${r?.data?.sent ?? 0} tester(s) with a sign-in link`);
    } catch (err) {
      notifyError(errMsg(err, "Emailing testers"));
    }
  };

  const flag = async (id, changes) => {
    try {
      const r = await appsApi.patch(`/files/${id}`, changes);
      patch(id, r?.data);
      if ("hidden" in changes) toast.success(changes.hidden ? "Hidden from testers" : "Visible to testers");
      else toast.success(changes.latest ? "Marked as Latest" : "Latest badge removed");
    } catch (err) {
      notifyError(errMsg(err, "Updating the file"));
    }
  };

  const restore = async (id, name) => {
    try {
      await appsApi.post(`/files/${id}/restore`);
      await load();
      onChange();
      toast.success(`Restored ${name}`);
    } catch (err) {
      notifyError(errMsg(err, "Restoring the file"));
    }
  };

  const stop = async (id, name) => {
    try {
      await appsApi.post(`/files/${id}/cancel`);
      toast.success(`Stopping ${name}. It will disappear from the list in a moment.`);
      await load();
    } catch (err) {
      notifyError(errMsg(err, "Stopping the save"));
    }
  };

  const remove = async (id, name) => {
    try {
      await appsApi.delete(`/files/${id}`);
      setFiles((l) => l.filter((f) => f.id !== id));
      onChange();
      toast.success(`Deleted ${name}`, { duration: 10000, action: { label: "Undo", onClick: () => restore(id, name) } });
    } catch (err) {
      notifyError(errMsg(err, "Deleting the file"));
    }
  };

  return { notify, flag, stop, remove, patch };
};
